import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';
import { Component, OnInit, OnChanges, SimpleChanges, Input, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from '../../Service/app/login.service';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { NavbarService } from '../navbar.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import io from 'socket.io-client';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  count_machine:any;
  pri: any;
  primaryColor: string;
  modu_name:any;
    opened: boolean;
    public sidebarToggled = false;
  show1: boolean;
  @Input()navStatus: boolean;
  available:any;
  show2: boolean;
  drawer:any;
  tenant_name:any;
  sidebarnavigate:any;
  // private nav:any;
  // nav:any;
  showpages: any=[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  rolename: string;
  masterscreen:boolean=false
  productionscreen:boolean=true
  maintenancescreen:boolean=false
  qualityscreen:boolean=false
  maacroscreen:boolean=false
  notificationsscreen:boolean=false

  // Notifications
  notifications: { _id: string; message: string; machine: string; time: string; is_read: boolean; read_by: string[] }[] = [];
  unreadCount: number = 0;
  showNotifications: boolean = false;
  hasNewMessages: boolean = false;
  private socket: any;
  private userEmail: string = '';

  constructor(private http: HttpClient, private servie: LoginService, public nav: NavbarService, private route: Router, private breakpointObserver: BreakpointObserver) {
    this.nav.hide();

   }

  ngOnInit() {
    this.tenant_name = localStorage.getItem('ten_name');
    this.servie.true().pipe(untilDestroyed(this)).subscribe(res => {
      localStorage.setItem('sign', res);
    });
    this.rolename = localStorage.getItem('role_name');
    this.userEmail = localStorage.getItem('email') || '';
    this.loadNotifications();
    this.connectSocket();
  }

  loadNotifications() {
    if (!this.userEmail) return;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    this.http.get<any>(`${environment.serverUrl}message?email=${this.userEmail}&is_read=false`, { headers })
      .subscribe(res => {
        const list = Array.isArray(res) ? res : ((res && res.data) || []);
        const mapped = list.map(n => ({
          _id: (n._id && n._id.$oid) ? n._id.$oid : (n._id || ''),
          message: n.message,
          machine: n.machine,
          time: n.createdAt || n.time,
          read_by: n.read_by || [],
          is_read: (n.read_by || []).includes(this.userEmail)
        })).sort((a, b) => new Date(b.time).getTime() - new Date(a.time).getTime());
        this.notifications = [...mapped];
        this.unreadCount = this.notifications.filter(n => !n.is_read).length;
      }, err => console.error('[Notif] Load error:', err));
  }

  connectSocket() {
   this.socket = io(environment.serverUrl2, {
    transports: ["websocket"], // ✅ use this
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

    this.socket.on('connect', () => {
      console.log('[Socket] Connected, id:', this.socket.id);
    });

    this.socket.on('connect_error', (err) => {
      console.error('[Socket] Connection error:', err);
    });

    this.socket.on('notification', (data: { message: string; machine: string; time: string }) => {
      console.log('[Socket] notification received:', data);
      this.hasNewMessages = true;
      this.loadNotifications();
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.showNotifications) return;
    const wrapper = document.querySelector('.notif-wrapper');
    if (wrapper && !wrapper.contains(event.target as Node)) {
      this.showNotifications = false;
    }
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications) {
      this.hasNewMessages = false;
      this.loadNotifications();
    }
  }

  markAsRead(notif: any) {
    if (!notif._id || notif.is_read) return;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    this.http.put(`${environment.serverUrl}message_read?id=${notif._id}&email=${this.userEmail}`, {}, { headers })
      .subscribe(
        () => { this.loadNotifications(); },
        err => { console.error('[Notif] Mark read error:', err); this.loadNotifications(); }
      );
  }

  markAllAsRead() {
    const unread = this.notifications.filter(n => !n.is_read && n._id);
    if (!unread.length) return;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    let completed = 0;
    unread.forEach(n => {
      this.http.put(`${environment.serverUrl}message_read?id=${n._id}&email=${this.userEmail}`, {}, { headers })
        .subscribe(() => {
          completed++;
          if (completed === unread.length) { this.loadNotifications(); }
        }, err => console.error('[Notif] Mark all read error:', err));
    });
  }

  deleteNotification(notif: any) {
    if (!notif._id) {
      this.notifications = this.notifications.filter(n => n !== notif);
      this.unreadCount = this.notifications.filter(n => !n.is_read).length;
      return;
    }
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    this.http.delete(`${environment.serverUrl}message?id=${notif._id}`, { headers })
      .subscribe(
        () => { this.loadNotifications(); },
        err => { console.error('[Notif] Delete error:', err); this.loadNotifications(); }
      );
  }

  clearNotifications() {
    this.notifications = [];
    this.unreadCount = 0;
  }
  screenshow1(){
    if(this.masterscreen){
      this.masterscreen=false
    }else{
      this.masterscreen=true
    }
   
  }
  screenshow2(){
    if(this.productionscreen){
      this.productionscreen=false
    }else{
      this.productionscreen=true
    }
   
  }    
  screenshow3(){
    if(this.maintenancescreen){
      this.maintenancescreen=false
    }else{
      this.maintenancescreen=true
    }
   
  } 
  screenshow4(){
    if(this.qualityscreen){
      this.qualityscreen=false
    }else{
      this.qualityscreen=true
    }
   
  } 
  screenshow5(){
    if(this.maacroscreen){
      this.maacroscreen=false
    }else{
      this.maacroscreen=true
    }

  }
  screenshow6(){
    if(this.notificationsscreen){
      this.notificationsscreen=false
    }else{
      this.notificationsscreen=true
    }
  }
  hidepages(val: any): boolean {
    // Get the pagelist from localStorage
    const pagelistString = localStorage.getItem("pagelist");
  
    // Check if pagelistString is null
    if (pagelistString === null) {
      return false; // Return false if pagelistString is null
    }
  
    // Parse the pagelist string into an array
    this.showpages = JSON.parse(pagelistString);
  
    // Check if the value exists in the showpages array
    return this.showpages.includes(val);
  }
  changeTheme(primary: string) {

    console.log(primary)

    console.log(primary);
    localStorage.setItem('pri_mary_col_vapmso', primary);
  
  
    document.documentElement.style.setProperty('--primary-color', primary);
  
  }
 


    // pickRedInt(){
    //   const toread = (<HTMLInputElement>document.getElementById('color_pick')).value;
    //   const r_value = (parseInt(toread.substr(1,2), 16));
    //   const g_value = (parseInt(toread.substr(3,2), 16));
    //   const b_value = (parseInt(toread.substr(5,2), 16));
    //   const all_rgb = [r_value, g_value, b_value ];
    //   console.log(r_value,g_value,b_value);    
    //   document.documentElement.style.setProperty('--primary-color', all_rgb);
  
    // }
    
     


  shift(){
    this.hides()
    this.servie.machine_count().pipe(untilDestroyed(this)).subscribe(res=>{
      this.count_machine = res.shift_data;
      if(this.count_machine === false){
          Swal.fire({
            title: 'Register Shift',
            // type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.value) {
              localStorage.clear();
              this.route.navigateByUrl('/shift');
            }
          });

      }
      else{
        this.route.navigateByUrl('/main-dashboard');
        if(window.innerWidth  < 600){
          this.toggleSidebar();
        }

      }
  // debugger
     

    })
  
   

   
  }
  oeeclick(){
    let assidebar = document.querySelector('.sidenav');
    let body = document.querySelector('body');
     if(window.innerWidth  >= 1920 || window.innerWidth  < 600){
      this.toggleSidebar();
    //   if(assidebar.classList.contains('sss' || '' ))    
    // {
    //   assidebar.classList.add('sidebar-hidden');
    //     body.classList.add('activemenu');
    //     assidebar.classList.remove('sss');
    // }
    // else
    // { 
    //   assidebar.classList.remove('sidebar-hidden');
    //   body.classList.remove('activemenu');
    //   assidebar.classList.add('sss');
    
    // }
    }

     
  
  }
  shifting(){
   
   
    if(window.innerWidth  < 600){
      this.toggleSidebar();
    }
    
 
   
    
  }
  ngOnChanges(changes: SimpleChanges) {
    const urlPath = window.location.pathname;
    if(urlPath === "/main-dashboard" ){
      console.log(urlPath);
      this.hides()
    }
    if(changes.navStatus.currentValue){
      this.pri = localStorage.getItem('color_theme')
      console.log(this.pri);
      this.changeTheme(this.pri);
      this.tenant_name = localStorage.getItem('ten_name');
      this.modu_name = localStorage.getItem('mod_name');
      this.rolename = localStorage.getItem('role_name');
      this.available =  localStorage.getItem('disable');
      if(window.innerWidth  < 600){
        this.toggleSidebar();
      }
     

    }
  
     

} 
 view() {
    this.show2 = !this.show2
  }
  toggle() {
    this.show1 = !this.show1
  }
  // close() {
  //   Swal.fire({
  //     title: 'Are you sure want to logout?',
  //     // icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then((result) => {
  //     if (result) {
  //       localStorage.clear();
  //       this.route.navigateByUrl('');
  //     }
  //   });
  // }

  refresh(){
    location.reload();
  }
 // toggle sidebar
// toggle sidebar
hides(){
  let assidebar = document.querySelector('.sidenav');
  let body = document.querySelector('body');
  assidebar.classList.add('sidebar-hidden');
  body.classList.add('activemenu');
  assidebar.classList.remove('sss');
}

toggleSidebar() {
  let assidebar = document.querySelector('.sidenav');
  let body = document.querySelector('body');
  
  console.log(assidebar);
 
    this.sidebarToggled = !this.sidebarToggled;
    console.log(this.sidebarToggled );
    //  debugger
    if(window.innerWidth  < 600){
      if (assidebar.classList.contains('sss') || assidebar.classList.contains('')) 
   
      {
        assidebar.classList.add('sidebar-hidden');
          body.classList.add('activemenu');
          assidebar.classList.remove('sss');
      }
      else
      { 
        assidebar.classList.remove('sidebar-hidden');
        body.classList.remove('activemenu');
        assidebar.classList.add('sss');
      
      }
    }
   else if (window.innerWidth  >= 1920){
      //   if(assidebar.classList.contains('sss' || '' ))    
    // {
    //   assidebar.classList.add('sidebar-hidden');
    //     body.classList.add('activemenu');
    //     assidebar.classList.remove('sss');
    // }
    // else
    // { 
    //   assidebar.classList.remove('sidebar-hidden');
    //   body.classList.remove('activemenu');
    //   assidebar.classList.add('sss');
    
    // }
    if (assidebar.classList.contains('sss') || assidebar.classList.contains(''))
   
      {
        assidebar.classList.add('sidebar-hidden');
          body.classList.add('activemenu');
          assidebar.classList.remove('sss');
      }
      else
      { 
        assidebar.classList.remove('sidebar-hidden');
        body.classList.remove('activemenu');
        assidebar.classList.add('sss');
      
      }
    }
else{
if(this.sidebarToggled) {
  assidebar.classList.add('sidebar-hidden');
  body.classList.add('activemenu');
  assidebar.classList.remove('sss');
} 
else {
  assidebar.classList.remove('sidebar-hidden');
  body.classList.remove('activemenu');
  assidebar.classList.add('sss');
}
}
  

   
}
toggleSidebar1(){
  let assidebar = document.querySelector('.sidenav');
  let body = document.querySelector('body');
  
  console.log(assidebar);
 
    this.sidebarToggled = !this.sidebarToggled;
    console.log(this.sidebarToggled );
    assidebar.classList.remove('sidebar-hidden');
    body.classList.remove('activemenu');
    assidebar.classList.add('sss');
}

  ngOnDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
  close() {
    this.toggleSidebar1();
    Swal.fire({
      title: 'Are you sure you want to log out?',
      // type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        localStorage.clear();
        this.route.navigateByUrl('');
      }
    });
  }
}



